import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import React from "react";
import { Card } from "react-bootstrap";
import FormCheckLabel from "react-bootstrap/esm/FormCheckLabel";
import { DataContext } from "../../../App";
import { Images } from "../../../Utils/logos";
import parseCoveragesInCard from "../../../Utils/parseCoveragesInCard";
import { getIcon, getIconColor } from "../../../Utils/parseIcons";
import { onRequestOffer } from "../../../Utils/requestOffer";
import { FAVMESSAGE, ALLIANCEMESSAGEKEY } from "../../../Utils/variables";
import getAllianceMessage from "../../../Utils/Getters/getAllianceMessage";
import isAlliancePolicy from "../../../Utils/Checkers/isAlliancePolicy";
import "./Policy.css";

var formatter = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

function Policy({ policy, index, selected, setSelected, setDetailsPolicy }) {
  const { context } = React.useContext(DataContext);
  const coverages = React.useMemo(
    () => parseCoveragesInCard(policy.products[0].coverages, context.groups),
    [policy.products[0].coverages, context.groups]
  );

  const values = React.useMemo(
    () =>
      coverages
        .map((coverage) => {
          const res = {
            icon: getIcon(coverage.description),
            iconColor: getIconColor(coverage.description),
            key: coverage.description_tag,
            value: coverage.description,
          };
          return res;
        })
        //Add alliance message
        .concat(
          isAlliancePolicy(policy?.provider)
            ? [
                {
                  icon: getIcon("SI"),
                  iconColor: getIconColor("SI"),
                  key: ALLIANCEMESSAGEKEY,
                  value: getAllianceMessage(policy?.provider, false),
                },
              ]
            : []
        ),
    [coverages, policy?.provider]
  );

  const onSelect = (e, index) => {
    if (e.target.value) {
      setSelected([...selected, index]);
    } else {
      setSelected(selected.filter((item) => item !== index));
    }
  };

  return (
    <Card
      className={`border-radius policy-card ${
        policy.favorite ? "policy-card-fav" : ""
      }`}
      style={{ height: "100%" }}
    >
      {policy.view_status == "Recomendada" || policy.view_status == 1 ? (
        <div className="ribbon-card">
          <span className="ribbon-message">Recomendado</span>
        </div>
      ) : null}
      <div className="card-head-container">
        <div className="card-head-logo" style={{ height: 70 }}>
          <img
            alt={policy.products[0].manufacturer}
            src={Images[policy.products[0].manufacturer.toLowerCase()]}
            style={{ height: 70 }}
          />
        </div>
        <div className="card-head-title">
          <span
            className="mx-auto card-head-title-style"
            style={{ marginBottom: 0 }}
          >
            {policy.products[0].name
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
                letter.toUpperCase()
              )}
          </span>
        </div>
      </div>

      <div
        className="mx-auto mt-0 mb-auto row pl-4 pl-md-2 w-100"
        style={{
          marginTop: "1em",
          padding: "0.5em 1em 0 1em",
          fontSize: "0.8rem",
        }}
      >
        {values.map((value, idx) => (
          <div key={idx} className="w-100 card-info-line">
            <div className="card-info-container">
              <i
                className={value.icon}
                style={{ color: value.iconColor, marginRight: 5 }}
              ></i>
              <span>
                <span className="card-info-key">{value.key}</span>
                {": "}
                <span>{value.value}</span>
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center" style={{ paddingBottom: "1em" }}>
        <div className="card-price">
          <span
            className="card-price-span"
            style={{ color: "var(--price-color)", fontSize: "1em", margin: 0 }}
          >
            {formatter.format(policy.total_price)}
          </span>
          <p style={{ fontSize: "0.8em", margin: 0 }}>
            {policy.financing_installments &&
            policy.financing_installments.split
              ? policy.financing_installments?.split("::")[1]
                ? "O" + policy.financing_installments?.split("::")[1]
                : ""
              : ""}
          </p>
        </div>
        <div
          className="d-flex"
          style={{
            justifyContent: "space-around",
            padding: "0 15px",
            marginTop: "4px",
          }}
        >
          <div className="see-more-container">
            <Button
              className="third-button see-more-button card-button"
              onClick={() => {
                setDetailsPolicy(policy);
              }}
            >
              Ver más
            </Button>
          </div>
          {policy.favorite ? (
            <div className="fav-message-container">
              <span className="fav-message">{FAVMESSAGE}</span>
            </div>
          ) : (
            <Button
              className="sec-button card-button"
              onClick={() => onRequestOffer(context, policy.id_db)}
            >
              Solicitar
            </Button>
          )}
        </div>
        <div className="mt-2">
          <Checkbox
            defaultChecked={selected.includes(index)}
            className="pri-checkbox"
            onChange={(e) => onSelect(e, index)}
          />
          <FormCheckLabel style={{ marginLeft: "1em" }} className="text-muted">
            Añadir a Comparativo!
          </FormCheckLabel>
        </div>
      </div>
    </Card>
  );
}

export { Policy };
